import { Dates } from "@salaxy/core";
import QRCode from "qrcode";
/**
 * Helpers for generating qr code values.
 * @see https://www.finanssiala.fi/wp-content/uploads/2021/03/QR_koodin_kaytto_tilisiirtolomakkeella.pdf
 */
export class QrCodes {
  /**
   * Get the value as svg.
   * @param bic The BIC code.
   * @param nameOfReceiver The name of the receiver.
   * @param iban The IBAN.
   * @param ref The reference.
   * @param message The message.
   * @param amount The amount.
   * @param dueDate The due date.
   * @returns The value as svg.
   */
  public static async getValue(bic: string, nameOfReceiver: string, iban: string, ref?: string | undefined | null, message?: string | undefined | null, amount?: number, dueDate?: string | false): Promise<string> {
    if (!bic || !nameOfReceiver || !iban || (!ref && !message) || amount === undefined || amount === null) {
        // Handle error case
        return Promise.resolve("");
    }
    // Constant values. See documentation
    const serviceTag = "BCD";
    const version = "001";
    const characterSet = "1";
    const identificationCode = "SCT";

    // Remove white space from IBAN and ref
    iban = (iban + "").replace(/\s/g, "");
    if(ref) {
      ref = (ref + "").replace(/\s/g, "");
    }

    let QrCodeText = `${serviceTag}\n${version}\n${characterSet}\n${identificationCode}\n${bic}\n${nameOfReceiver}\n${iban}\n`;

    // Add amount
    if(amount >= 0.01 &&  amount <= 999999999.99){
      if(ref) {
        QrCodeText += `EUR${amount}\n\n`;
      } else {
        QrCodeText += `EUR${amount}\n\n\n`;
      }
    }

    // Add ref
    if(ref) {
      QrCodeText += `${ref}\n\n`;
    }

    // Add message
    if(!ref) {
      QrCodeText += `${message}\n`;
    }
    // Add due date
    if(dueDate) {
      QrCodeText += `ReqdExctnDt/${Dates.format(dueDate, "YYYY-MM-DD")}`;
    }
    //Added promise wrapper because angularjs environment disturbs promise with "$q"
    const doQR = (): Promise<string> => {
      return new Promise((resolve, _reject) => {
          QRCode.toString(QrCodeText,{type: "svg", errorCorrectionLevel: "L", version: 13}, function(err, url) {
            if(err) {
              console.error(err);
              resolve("");
            } else {
              resolve(url);
            }
          });
      });
    };
    return doQR();
  }
}